import { defineComponent as _defineComponent } from 'vue';
import { BFormCheckbox, BFormGroup } from "bootstrap-vue";
import { ref, watch } from "vue";
import localize from "@/utils/localization";
import HelpText from "@/components/Help/HelpText.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CollectionCreatorSourceOptions',
    props: {
        value: { type: Boolean },
        extensionsToggle: { type: Boolean },
        renderExtensionsToggle: { type: Boolean }
    },
    emits: ["input", "remove-extensions-toggle"],
    setup(__props, { emit }) {
        const props = __props;
        const localHideSourceItems = ref(props.value);
        // Watch for external updates to value and sync with innerValue
        watch(() => props.value, (newValue) => {
            localHideSourceItems.value = newValue;
        });
        watch(localHideSourceItems, (newValue) => {
            emit("input", newValue);
        });
        return { __sfc: true, props, localHideSourceItems, emit, BFormCheckbox, BFormGroup, localize, HelpText };
    }
});
